import {createContext} from "react";
import {IDriverContext} from "../types/driver.interface";

const DriverScreen = createContext<IDriverContext>({});

export default DriverScreen;
